import React from 'react';
import { useSnack } from '../hooks/useSnack';
import { useAuth } from '../hooks/useAuth';
import { ContainerStyled } from '../styles/Main';
import { CopySnack } from '../styles/Main';
import { IconContext } from "react-icons";
import iconMap from '../data/iconMap';
import styled from 'styled-components';

const VerifyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 20px;
  text-align: center;
`;

const EmailText = styled.p`
  font-size: 1.1rem;
  margin-bottom: 24px;
  color: ${({theme}) => theme.text};
`;

const ActionButton = styled.button`
  background: ${({$primary, theme}) => $primary ? theme.primary : 'transparent'};
  color: ${({$primary, theme}) => $primary ? '#fff' : theme.text};
  border: 1px solid ${({theme}) => theme.primary};
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  margin: 8px;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
`;

const VerifyEmail = () => {
  const { user, verificationEmail, logOut } = useAuth();
  const [snack, showSnack] = useSnack();

  const resendEmail = async () => {
    try {
      await verificationEmail();
      showSnack('Verification email sent!');
    } catch (err) {
      showSnack(err.message);
    }
  };

  const handleSignOut = async () => {
    try {
      await logOut();
    } catch (err) {
      showSnack(err.message);
    }
  };

  return (
    <ContainerStyled>
      <VerifyContainer>
        <h2 style={{marginBottom: '16px'}}>Verify Your Email</h2>
        <EmailText>
          We've sent a verification link to <strong>{user?.email}</strong>.
          <br />Please check your inbox and click the link to continue.
        </EmailText>
        
        {snack !== '' && (
          <CopySnack $size={200}>
            <IconContext.Provider value={{ style: { fontSize: '18px', color: 'green' } }}>
              {iconMap['Snack_Check']}
            </IconContext.Provider>
            {snack}
          </CopySnack>
        )}
        
        <ButtonRow>
          <ActionButton $primary onClick={resendEmail}>
            Resend Verification Email
          </ActionButton>
          <ActionButton onClick={handleSignOut}>
            Sign Out
          </ActionButton>
        </ButtonRow>
        
        <p style={{marginTop: '24px', fontSize: '0.9rem', opacity: 0.7}}>
          Already verified? Try refreshing the page.
        </p>
      </VerifyContainer>
    </ContainerStyled>
  );
};
 
export default VerifyEmail;